/**
 * Hinweise des Servers zum Feiertagskalender (`HolidayCalendarWarningCodes`) als Sätze. Solange einer
 * davon gilt, kennt die Automatik für das Objekt keine Feiertage. Unbekanntes bleibt mit Code sichtbar.
 */
const TEXT: Record<string, string> = {
  holiday_location_unavailable:
    'Feiertage: Für das Objekt ist kein Standort hinterlegt – Feiertage fließen nicht in die Preise ein.',
  holiday_subdivision_review_required:
    'Feiertage: Das Bundesland des Objekts ist noch nicht geklärt – Feiertage fließen nicht in die Preise ein.',
  holiday_calendar_cache_missing:
    'Feiertage: Der Feiertagskalender ist noch nicht geladen – Feiertage fließen nicht in die Preise ein.',
};

export const warningText = (code: string) => TEXT[code] ?? `Hinweis des Servers (${code})`;
